import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { RxRevcycleSummaryComponent } from './rx-revcycle-summary/rx-revcycle-summary.component';
import { AuthGuard } from 'src/app/core/guards/auth.guard';
import { FeatureGuard } from 'src/app/core/guards/feature.guard';
import { NoAccessComponent } from '../pages/no-access/no-access.component';
import { RxRevcycleViewComponent } from './rx-revcycle-view/rx-revcycle-view.component';
import { LandingPageComponent } from '../pages/landing-page/landing-page.component';

const routes: Routes = [
  {
    path: 'rx-revcycle',
    component: RxRevcycleSummaryComponent,
    canActivate: [AuthGuard, FeatureGuard],
    data: {
      feature: 'UI::BusinessIntelligence::RxRevCycle',
      shouldDetach: true,
    },
    children: [
      { path: '', redirectTo: 'analytics/home', pathMatch: 'prefix' },
      { path: 'analytics', redirectTo: 'analytics/:slugid', pathMatch: 'full' },
      {
        path: 'analytics/:slugid',
        component: RxRevcycleViewComponent,
      },
    ],
    runGuardsAndResolvers: 'always',
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class RxRevcycleRoutingModule {}
